import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-da-report',
  templateUrl: './da-report.component.html',
  styleUrls: ['./da-report.component.scss']
})
export class DaReportComponent implements OnInit {
  protected http: HttpClient;

  constructor(private route: ActivatedRoute, private cryptoJsService: CryptoJsService, private router: Router,private service: BaseService) { }


  items: any[];
  autoId: any;
  appId: any;
  selectedDate:any;
  date:any;
  activeItem: any;
  showTabs:boolean=false;
path:any
  ngOnInit() {
    let parentRoute = this.router.url.split('/')[1];
    
    
    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'MI', routerLink: `/${parentRoute}/report/da-report/mi`},
          { label: 'Pond', routerLink: `/${parentRoute}/report/da-report/pond` },
          
        ];
      }
      );
  }
  submitHandler(){
    this.path = this.router.url.split('/')[4];
    // console.log(this.selectedDate,"selectedDate.........selectedDate")
    this.date= ((this.selectedDate.getMonth() > 8) ? (this.selectedDate.getMonth() + 1) : ('0' + (this.selectedDate.getMonth() + 1))) + '/' + ((this.selectedDate.getDate() > 9) ? this.selectedDate.getDate() : ('0' + this.selectedDate.getDate())) + '/' + this.selectedDate.getFullYear()
    // console.log(this.selectedDate,"selectedDate.........MM/DD/YYYY")
    this.service.changeDate(this.date)
    // this.showTabs=false;
    this.showTabs=true;
    
    if(this.path=='mi'){
      // console.log(this.path,"this.paththis.paththis.paththis.paththis.path")
      this.router.navigate(['/department/report/da-report/pond']);
      
    }
    
    else if(this.path=='pond'){
      this.router.navigate(['/department/report/da-report/mi']);
      // console.log(this.path,"this.paththis.paththis.paththis.paththis.path")
    }
    else{
      this.router.navigate(['/department/report/da-report/mi']);
    }
    
  }
  // onSelectedTable(event:any):{
  //  console.log(event,"event")
  // }

}
